export enum SubscriptionStatus {
  Inactive = 0,
  Pending = 100,
  Active = 200,
  Expired = 300,
  Used = 301,
  Errored = 302,
  Suspended = 400,
  Upgraded = 500,
  UpgradePending = 550,
  UpgradeFailed = 570,
  Transferred = 600,
  Canceled = 700,
  CanceledPending = 800,
  PastDue = 900,
  Presale = 1000,
  ProcessingFailed = 1100,
}

// the server converts the number to a string enum in a lot of objects
export enum SubscriptionStatusString {
  Inactive = "Inactive",
  Pending = "Pending",
  Active = "Active",
  Expired = "Expired",
  Used = "Used",
  Errored = "Errored",
  Suspended = "Suspended",
  Upgraded = "Upgraded",
  UpgradePending = "UpgradePending",
  UpgradeFailed = "UpgradeFailed",
  Transferred = "Transferred",
  Canceled = "Canceled",
  CanceledPending = "CanceledPending",
  PastDue = "PastDue",
  Presale = "Presale",
  ProcessingFailed = "ProcessingFailed",
}
